export default "__VITE_ASSET__BvpVMt6S__"